/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useMemo, useState } from 'react'

import { Button, Link } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import {
  authUrls,
  SERVICES_URL,
  useLocale,
  useQueryUser,
  useTranslation
} from '@plandi/common'
import { useCreateButtonsStyles } from './create-buttons.style'

interface ICreateButtonsProps {
  place?: string
}

interface ICreateButtn {
  title?: string
  href?: string
  hrefAuth?: string
}

export const CreateButtons: FC<ICreateButtonsProps> = ({ place }) => {
  const [createButton, setCreateButton] = useState<ICreateButtn>({})
  const locale = useLocale()
  const { data: translate } = useTranslation()
  const { data: user } = useQueryUser(locale)
  const url = SERVICES_URL

  const classes = useCreateButtonsStyles()

  const createButtonProject = useMemo(
    () => ({
      title: translate?.market?.buttons?.['create-project'] ?? 'Создать проект',
      href:
        locale === 'ru'
          ? `${url.shop}/ru/projects/create`
          : url.shop + '/projects/create',
      hrefAuth:
        locale === 'ru'
          ? authUrls(locale).signIn +
            `?redirectUrl=${`${url.shop}/ru` + '/projects/create'}`
          : authUrls(locale).signIn +
            `?redirectUrl=${url.shop + 'projects/create'}`
    }),
    [locale]
  )
  const createButtonModel = useMemo(
    () => ({
      title:
        translate?.market?.buttons?.['create-model'] ?? 'Создать BIM-модель',
      href:
        locale === 'ru'
          ? `${url.shop}/ru/models/create`
          : url.shop + '/models/create',
      hrefAuth:
        locale === 'ru'
          ? authUrls(locale).signIn +
            `?redirectUrl=${`${url.shop}/ru` + '/models/create'}`
          : authUrls(locale).signIn +
            `?redirectUrl=${url.shop + '/models/create'}`
    }),
    [locale]
  )
  const createButtonProduct = useMemo(
    () => ({
      title: translate?.market?.['сreate-product'] ?? 'Создать товар',
      href:
        locale === 'ru'
          ? `${url.shop}/ru/goods/create`
          : url.shop + '/goods/create',
      hrefAuth:
        locale === 'ru'
          ? authUrls(locale).signIn +
            `?redirectUrl=${`${url.shop}/ru` + '/goods/create'}`
          : authUrls(locale).signIn +
            `?redirectUrl=${url.shop + '/goods/create'}`
    }),
    [locale]
  )

  useEffect(() => {
    if (place === 'project') setCreateButton(createButtonProject)
    if (place === 'model') setCreateButton(createButtonModel)
    if (place === 'product') setCreateButton(createButtonProduct)
  }, [place, locale])

  return (
    <div className={classes.container}>
      <Link
        href={user ? createButton?.href : createButton?.hrefAuth}
        className={classes.linkAdd}
      >
        <Button
          variant="contained"
          color="secondary"
          startIcon={<AddIcon />}
          className={classes.buttonAdd}
        >
          {createButton?.title}
        </Button>
      </Link>
    </div>
  )
}
